// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBaqXTN5p9Av5vunZmAIwfrXlnfVS-FSCM",
    authDomain: "mastergymef.firebaseapp.com",
    databaseURL: "https://mastergymef.firebaseio.com",
    projectId: "mastergymef",
    storageBucket: "mastergymef.appspot.com",
    messagingSenderId: "363289896291",
    appId: "1:363289896291:web:ceaa9c8d33af4052041f56",
    measurementId: "G-6EMS93H2K5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
